import { Anchor, List, Title } from '@mantine/core';
import React from 'react';
import './index.less';
import logo from '../images/logo.svg';
import logoInverse from '../images/logo-inverse.svg';
import beian from '../images/beian.png';
import { Link } from 'gatsby';

const casesChildren = [
  { link: '/cases/pulp-bleaching', name: '常规过氧化氢应用' },
  { link: '/cases/electronic-grade', name: '电子级过氧化氢应用' },
];

const initialLinks = [
  { link: '/', name: '公司介绍' },
  {
    name: '现场化学品生产', children: [
      { link: '/product', name: '双氧水现场生产技术', value: 0 },
      { link: '/partner', name: '双氧水工厂伙伴', value: 1 },
    ]
  },
  { key: 'cases', name: '应用与案例', children: casesChildren },
  { link: '/news', name: '新闻资讯' },
  { link: '/about', name: '联系我们' },
];

const footerLinks = [
  { link: '/', name: '公司介绍' },
  { link: '/#p2x', name: 'P2X理念' },
  { link: '/product', name: '现场化学品生产' },
  { link: '/product#tech', name: '储能技术' },
  { link: '/partner', name: '双氧水伙伴工厂' },
  { link: '/cases/pulp-bleaching', name: '常规过氧化氢应用' },
  { link: '/cases#download', name: '下载资料' },
  { link: '/news', name: '新闻资讯' },
  { link: '/about', name: '联系我们' },
];

function normalizePath(p: string) {
  return (p || '/').replace(/\/$/, '') || '/';
}

function subLinkActive(pathname: string, search: string, link: string) {
  const [pathPart, queryPart] = link.split('?');
  const cleanPath = normalizePath(pathPart || '/');
  const path = normalizePath(pathname);
  if (queryPart !== undefined && queryPart !== '') {
    return path === cleanPath && search === `?${queryPart}`;
  }
  return path === cleanPath || path.startsWith(`${cleanPath}/`);
}

function parentMenuActive(
  item: { children?: { link: string }[] },
  pathname: string,
  search: string
) {
  return !!(item.children && item.children.some((sub) => subLinkActive(pathname, search, sub.link)));
}

/** 一级链接高亮；新闻详情页归入「新闻资讯」 */
function isTopNavActive(pathname: string, search: string, link: string, currentPath: string) {
  if (link === '/news') {
    const head = (pathname || '/').split('/').filter(Boolean)[0];
    return head === 'news' || head === 'newsDetail';
  }
  return currentPath === link;
}

function Layout({ location, children }: { children: React.ReactNode, location: any }) {
  const links = initialLinks;

  const currentPath = '/' + location.pathname.split('/')[1] + location.search;
  const pathNorm = location.pathname || '/';
  const searchNorm = location.search || '';

  return (<>
    <header>
      <div className="logo-container">
        <img className="logo" src={logo} />
      </div>
      <nav>
        <div className="links-container">
          {links.map((item, index) => (item.link ?
            <Link
              key={item.link}
              className={isTopNavActive(pathNorm, searchNorm, item.link, currentPath) ? 'active' : ''}
              to={item.link || ''}
            >
              {item.name}
            </Link>
            : <a
              key={(item as { key?: string }).key || item.name}
              className={
                'menu' +
                (parentMenuActive(item, pathNorm, searchNorm) ? ' nav-parent-active' : '')
              }
              style={{zIndex: 100 - index}}
            >
              {item.name}
              {item.children && (<div className='children'>
                {item.children.map(subItem => (
                  <Link
                    key={subItem.link}
                    className={subLinkActive(pathNorm, searchNorm, subItem.link) ? 'active' : ''}
                    to={subItem.link || ''}
                  >{subItem.name}</Link>
                ))}
              </div>)}
            </a>
          ))}
        </div>
      </nav>
    </header>
    <main>
      {children}
    </main>
    <footer>
      <div className="container">
        <div className="company">
          <div className="logo-container">
            <img className="logo" src={logoInverse} />
          </div>
          <p className="intro">橙氧科技是一家专注于电化学领域的硬科技企业。橙氧科技的目标和愿景是使用基于公司领先的新型流体扩散电极的高效电化学反应系统，将其应用于双碳背景下的可再生电力多元转化（Power-to-X）领域，特别是大宗化学品生产（Power-to-Chemicals）的细分行业，用创新技术市场化的解决传统化工行业的巨大减排压力。</p>
        </div>
        <div className="links">
          <Title className='title' order={2}>快速链接</Title>
          <List>
            {footerLinks.map(item => (<Anchor
              key={item.link}
              href={item.link}
            >{item.name}</Anchor>))}
          </List>
        </div>
        <div className="contract">
          <Title className="title" order={2}>联系我们</Title>
          <span>info@chengyangtech.com</span>
          <span>杭州市余杭区文一西路1001号衢州海创园A座</span>
          <span>0571-88583989</span>
        </div>
      </div>
      <div className="copyright">
        <div>
          <span>版权所有 &copy; {(new Date()).getFullYear()}</span>
          <span>上海橙氧科技有限公司</span>
          <Link to="/privacy">隐私条款</Link>
        </div>
        <div className='beian'>
          <Anchor href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33060302000783" target="_blank">
            <img src={beian} /> 浙公安网备33060302000783号
          </Anchor>
          <Anchor href="http://beian.miit.gov.cn/" target="_blank">浙ICP备20022661号</Anchor>
        </div>
      </div>
    </footer>
  </>);
}

export default Layout;
